import actions from "./actions";

const initState = {
    planResult: [],
    planData: [],
    planRegion: [],
    planDay: [],
    loading: false,
    buttonLoading: false,
    getPlanLoading: false,
    planError: null,
    planMessage: null,
    buttonloading: false,
    planFormModal: false,
    cronusInventoryData: [],
    trafficPolicyResult: [],
    packageView: false,
    planViewModal: false,
    planViewModalData: [],
    planBundleName: [],
    bundleError: null,
    planNameMessage: null,

    getEsimTravelBundleLoading: false,
    getEsimTravelBundleData: [],
    getEsimTravelBundleError: null,

    getENKTmobileBundleLoading: false,
    getENKTmobileBundleData: [],
    getENKTmobileBundleError: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.GET_ENK_TMOBILE_BUNDLE:
            return {
                ...state,
                getENKTmobileBundleLoading: true,
                getENKTmobileBundleData: [],
                getENKTmobileBundleError: null,
                getEsimTravelBundleData: [],
                planBundleName: [],
            };
        case actions.GET_ENK_TMOBILE_BUNDLE_SUCCESS:
            return {
                ...state,
                getENKTmobileBundleLoading: false,
                getENKTmobileBundleData: action.payload.data,
                getENKTmobileBundleError: null,
            };
        case actions.GET_ENK_TMOBILE_BUNDLE_FAILED:
            return {
                ...state,
                getENKTmobileBundleLoading: false,
                getENKTmobileBundleData: [],
                getENKTmobileBundleError: action.payload.error,
            };


        case actions.GET_ESIM_TRAVEL_BUNDLE:
            return {
                ...state,
                getEsimTravelBundleLoading: true,
                getEsimTravelBundleData: [],
                getEsimTravelBundleError: null,
                bundleError: null,
                planBundleName: [],
            };
        case actions.GET_ESIM_TRAVEL_BUNDLE_SUCCESS:
            return {
                ...state,
                getEsimTravelBundleLoading: false,
                getEsimTravelBundleData: action.payload.data,
                getEsimTravelBundleError: null,
            };
        case actions.GET_ESIM_TRAVEL_BUNDLE_FAILED:
            return {
                ...state,
                getEsimTravelBundleLoading: false,
                getEsimTravelBundleData: [],
                getEsimTravelBundleError: action.payload.error,
            };


        case actions.GET_PLAN:
            return {
                ...state,
                loading: true,
                buttonLoading: false,
                planMessage: null,
                planError: null,
                buttonloading: false,
                planFormModal: false,
            };
        case actions.GET_PLAN_SUCCESS:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planResult: action.planResult,
                planMessage: null,
                planError: null,
                buttonloading: false,
                planFormModal: false,
            };
        case actions.GET_PLAN_FAILED:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planError: action.planError,
                planMessage: null,
                buttonloading: false,
                planFormModal: false,
            };

        case actions.ADD_PLAN:
            return {
                ...state,
                loading: false,
                buttonLoading: true,
                planMessage: null,
                planError: null,
                buttonloading: true,
                planFormModal: true,
            };
        case actions.ADD_PLAN_SUCCESS:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planError: null,
                planMessage: action.planMessage,
                planResult: action.planResult,
                buttonloading: false,
                planFormModal: false,
            };
        case actions.ADD_PLAN_FAILED:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planError: action.planError,
                planMessage: null,
                buttonloading: false,
                planFormModal: true,
            };

        case actions.GET_PLAN_DATA:
            return {
                ...state,
                getPlanLoading: true,
                planError: null,
                planMessage: null,
                buttonloading: true,
                planFormModal: false,
            };
        case actions.GET_PLAN_DATA_SUCCESS:
            return {
                ...state,
                getPlanLoading: false,
                planError: null,
                planMessage: null,
                buttonloading: false,
                planFormModal: false,
                planData: action.planData,
            };
        case actions.GET_PLAN_DATA_FAILED:
            return {
                ...state,
                getPlanLoading: false,
                planError: action.planError,
                planMessage: null,
                buttonloading: false,
                planFormModal: false,
            }
        case actions.GET_PLAN_DAY:
            return {
                ...state,
                getPlanLoading: true,
                planError: null,
                planMessage: null,
                buttonloading: true,
                planFormModal: false,
            };
        case actions.GET_PLAN_DAY_SUCCESS:
            return {
                ...state,
                getPlanLoading: false,
                planError: null,
                planMessage: null,
                buttonloading: false,
                planFormModal: false,
                planDay: action.planDayData,
            };
        case actions.GET_PLAN_DAY_FAILED:
            return {
                ...state,
                getPlanLoading: false,
                planError: action.planError,
                planMessage: null,
                buttonloading: false,
                planFormModal: false,
            }
        case actions.GET_BUNDLE_NAME_DATA:
            return {
                ...state,
                getPlanLoading: true,
                planError: null,
                planMessage: null,
                buttonloading: true,
                getEsimTravelBundleData: [],
            };
        case actions.GET_BUNDLE_NAME_DATA_SUCCESS:
            return {
                ...state,
                getPlanLoading: false,
                planError: null,
                planMessage: null,
                buttonloading: false,
                planBundleName: action.planBundleName,
                bundleError: null

            };
        case actions.GET_BUNDLE_NAME_DATA_FAILED:
            return {
                ...state,
                getPlanLoading: false,
                bundleError: action.bundleError,
                planMessage: null,
                buttonloading: false,
                planFormModal: true,
                planBundleName: []
            }
        case actions.DELETE_PLAN:
            return {
                ...state,
                loading: false,
                planMessage: null,
                planError: null,
                buttonloading: true,
                planFormModal: false,
            };
        case actions.DELETE_PLAN_SUCCESS:
            return {
                ...state,
                loading: false,
                planError: null,
                planMessage: action.planMessage,
                planResult: action.planResult,
                buttonloading: false,
                planFormModal: false,
            };

        case actions.PREPARE_PLAN_FORM:
            return {
                ...state,
                planFormModal: true
            };

        case actions.RESET_PLAN:
            return {
                ...state,
                loading: false,
                planError: null,
                planMessage: null,
                buttonloading: false,
                planFormModal: false,
                planBundleName: [],
                bundleError: null,
            };
        case actions.RESET_PLAN_MESSAGE:
            return {
                ...state,
                loading: false,
                planError: null,
                planMessage: null,
                buttonloading: false,
                planNameMessage: null
            };

        case actions.CHECK_PLAN_NAME:
            return {
                ...state,
                planError: null,
                planMessage: null,
            };
        case actions.CHECK_PLAN_NAME_SUCCESS:
            return {
                ...state,
                planError: null,
                planNameMessage: action.message,
            };
        case actions.CHECK_PLAN_NAME_FAILED:
            return {
                ...state,
                planError: action.error,
                planMessage: null,
            };
        case actions.RESET_PLAN_BUNDLE:
            return {
                ...state,
                planBundleName: [],
                bundleError: null,
                getEsimTravelBundleData: [],
                getEsimTravelBundleError: null,
                getENKTmobileBundleLoading: false,
                getENKTmobileBundleData: [],
                getENKTmobileBundleError: null,
            };

        default:
            return state;
    }
}